import { ISessionStorageUsable } from 'interfaceAdapter/gatewaySchemas/ISessionStorageUsable';

export class SessionStorageUsable implements ISessionStorageUsable {
    constructor(private readonly prefix?: string, private readonly key?: string) {}

    get(): string | null {
        if (typeof window === 'undefined') {
            return null;
        }
        const fullKey = `${this.prefix}${this.key}`;
        return sessionStorage.getItem(fullKey);
    }

    set(value: string | number) {
        if (typeof window === 'undefined') {
            return;
        }
        const fullKey = `${this.prefix}${this.key}`;
        sessionStorage.setItem(fullKey, String(value));
    }

    remove() {
        if (typeof window === 'undefined') {
            return;
        }
        const fullKey = `${this.prefix}${this.key}`;
        sessionStorage.removeItem(fullKey);
    }
}
